module.exports = __webpack_public_path__ + "img/portfolio-07.5dee8713.jpg";